import React, { useState, Fragment, useEffect, useMemo } from "react";
import { Card, Row, Col, Spinner, Button } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { Link, useNavigate } from "react-router-dom";
import {
  createCourseDetails,
  getCourses,
  getDraftCourses,
  publishTheCourse,
} from "ServerAPI/serverAPI";
import CommonHeader from "layouts/dashboard/CommonHeader";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import courseIcon from "../../assets/images/Courses.svg";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import {
  FormControlLabel,
  FormGroup,
  IconButton,
  Switch,
  Tab,
  Tabs,
  TextField,
  Tooltip,
} from "@mui/material";
import { courseLevelStyle } from "constants/Constants";
import actionIcon from "../../assets/images/course/action-icon.svg";
import deleteIcon from "../../assets/images/add-course/delete.svg";
// import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import ToastMessage from "components/Dialog/ToastMessage";
import RefreshButton from "components/elements/refresh-button/RefreshButton";
import { useToast } from "context/toast-context/ToastProvider";
import { useLoader } from "components/loader/GlobalLoader";
import { FEATURES, useFeaturePermissions } from "constants/FeaturePermissions";

const AllCourses = () => {
  const [cookies] = useCookies();
  const { hasFeature } = useFeaturePermissions();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const { showToast } = useToast();
  const { showLoader, hideLoader } = useLoader();
  const [shouldPublishCourse, setShouldPublishCourse] = useState(false);
  const [clickedCourseId, setClickedCourseId] = useState("");
  const [publishCourseLoading, setPublishCourseLoading] = useState(false);
  const [isTableView, setIsTableView] = useState(
    [
      "platformCoordinator",
      "customerSuccessManager",
      "organizationCoordinator",
      "programCoordinator",
      "instructor",
      "courseManager",
    ].includes(cookies.roleId)
  );
  const [openDeleteCOnfirmationModal, setOpenDeleteCOnfirmationModal] =
    useState(false);
  const [clickedCourse, setClickedCourse] = useState({});
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [isDeleteCourseLoading, setIsDeleteCourseLoading] = useState(false);
  const navigate = useNavigate();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [tabValue, setTabValue] = useState("draft");
  const [draftCourses, setDraftCourses] = useState([]);
  const [checked, setChecked] = useState(false);
  const [pendingChecked, setPendingChecked] = useState(null); // holds temp value for confirmation
  const [displayType, setDisplayType] = useState("draft");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleCloseForPublishCourse = () => {
    setShouldPublishCourse(false);
    setPendingChecked(null);
  };
  const handleAddCourse = () => {
    navigate("/add-new-course/");
  };
  const activeTabStyle = useMemo(
    () => ({
      backgroundColor: "white",
      color: "rgba(34, 75, 153, 1)",
      fontWeight: "bold",
    }),
    []
  );
  const handleSwitchChange = (event, courseId) => {
    setShouldPublishCourse(true);
    setClickedCourseId(courseId);
    setPendingChecked(event.target.checked); // store intended change
  };

  const fetchCourses = async () => {
    try {
      let response = null;
      setLoading(true);
      let formattedData = {};
      if (displayType === "draft") {
        response = await getDraftCourses(
          cookies.email,
          cookies.roleId,
          cookies.organizationId,

          cookies.userId
        );
      } else {
        response = await getCourses(
          cookies.email,
          cookies.roleId,
          cookies.organizationId,
          cookies.department,
          cookies.userId
        );
      }

      if (
        cookies.roleId === "organizationCoordinator" ||
        cookies.roleId === "courseManager"
      ) {
        formattedData = response.data.map((course, index) => ({
          id: index + 1,
          title: course.courseTitle,
          description: course.courseDescription,
          level: course.courseLevel,
          courseId: course.courseId,
          courseDepartment: course.courseDepartment,
          courseDomain: course.courseDomain,
          totalParticipants: course.totalParticipants,
          published: course?.published,
          completionPercentage: course.completionPercentage
            ? course.completionPercentage.toFixed(2)
            : "0.00",
        }));
      } else {
        formattedData = response.data.map((course, index) => ({
          id: index + 1,
          title: course.courseTitle,
          description: course.courseDescription,
          level: course.courseLevel,
          courseId: course.courseId,
          courseDepartment: course.courseDepartment,
          courseDomain: course.courseDomain,
          published: course?.published,
          actions: <h1>gtkrgh</h1>,
        }));
      }
      setData(formattedData);
      setAllCourses(formattedData);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  console.log("data_", data);

  useEffect(() => {
    fetchCourses();
  }, [cookies.email, cookies.roleId, displayType]);

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await fetchCourses();
    setIsRefreshing(false);
  };
  const handleStatusToggle = async () => {
    // showLoader();
    setPublishCourseLoading(true);
    const payload = {
      courseId: clickedCourseId,
    };

    const response = await publishTheCourse(payload);
    if (response.status === 200) {
      showToast("course published", "success");
      fetchCourses();
    } else {
      showToast("course publish failed", "error");
    }
    handleCloseForPublishCourse();
    setPublishCourseLoading(false);
    // hideLoader();
  };
  const updateCourse = (cell) => {
    navigate("/add-new-course", {
      state: { editSavedCourse: true, courseId: cell.original.courseId },
    });
  };
  const goToViewCourse = (courseId) => {
    navigate(`/view-course/${courseId}`);
  };
  const columns = useMemo(() => {
    const baseColumns = [
      {
        accessorKey: "id",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>SN</span>
        ),
        cell: ({ getValue }) => (
          <span
            style={{ whiteSpace: "normal", textAlign: "center", width: "5%" }}
          >
            {getValue()}
          </span>
        ),
        size: "5%",
      },
      {
        accessorKey: "title",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>Title</span>
        ),
        cell: ({ getValue, row }) => (
          <Button
            variant="primary"
            size="sm"
            style={{ width: "100%", textAlign: "left" }}
            onClick={() => {
              navigate(`/view-course/${row.original.courseId}`);
            }}
          >
            {getValue()}
          </Button>
        ),
        size: "20%",
      },

      {
        accessorKey: "description",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>
            Description
          </span>
        ),
        cell: ({ getValue, row }) => (
          <>
            {" "}
            <Tooltip title={row.original.description}>
              <span
                variant="primary"
                size="sm"
                style={{ width: "100%", textAlign: "left" }}
              >
                {getValue()?.length > 50
                  ? getValue()?.slice(0, 50) + "..."
                  : getValue()}
              </span>
            </Tooltip>
          </>
        ),
        size: "30%",
      },

      {
        accessorKey: "courseDepartment",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>
            Department
          </span>
        ),
        cell: ({ getValue }) => (
          <span
            style={{ whiteSpace: "normal", textAlign: "left", width: "25%" }}
          >
            {getValue()}
          </span>
        ),
        size: "10%",
      },
      {
        accessorKey: "courseDomain",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>Domain</span>
        ),
        cell: ({ getValue }) => (
          <span
            style={{ whiteSpace: "normal", textAlign: "left", width: "25%" }}
          >
            {getValue()}
          </span>
        ),
        size: "10%",
      },
      {
        accessorKey: "level",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>Level</span>
        ),
        cell: ({ getValue }) => (
          <div
            style={{
              whiteSpace: "normal",
              display: "flex",
              justifyContent: "center",
              padding: "8px",
              borderRadius: "24px",
              width: "100%",
              background:
                (getValue() === "Beginner" &&
                  courseLevelStyle.beginner.backgroundColor) ||
                (getValue() === "Intermediate" &&
                  courseLevelStyle.intermediate.backgroundColor) ||
                ((getValue() === "Advance" || getValue() === "Advanced") &&
                  courseLevelStyle.advance.backgroundColor),
              color:
                (getValue() === "Beginner" &&
                  courseLevelStyle.beginner.color) ||
                (getValue() === "Intermediate" &&
                  courseLevelStyle.intermediate.color) ||
                ((getValue() === "Advance" || getValue() === "Advanced")&& courseLevelStyle.advance.color),
            }}
          >
            <span>
              <img
                src={
                  (getValue() === "Beginner" &&
                    courseLevelStyle.beginner.icon) ||
                  (getValue() === "Intermediate" &&
                    courseLevelStyle.intermediate.icon) ||
                  ((getValue() === "Advance" || getValue() === "Advanced")&& courseLevelStyle.advance.icon)
                }
              />
            </span>
            <span className="mx-2">{getValue()}</span>
          </div>
        ),
        size: "10%",
      },
      {
        accessorKey: "actions",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>Actions</span>
        ),
        size: "15%",
        cell: ({ row }) => {
          return (
            <>
              <div>
                {displayType === "draft" ? (
                  <>
                    {hasFeature(FEATURES.COURSE_UPLOAD) && (
                      <Tooltip title="Update">
                        <IconButton>
                          <span onClick={() => updateCourse(row)}>
                            <EditIcon />
                          </span>
                        </IconButton>
                      </Tooltip>
                    )}

                    <Tooltip title="Publish ">
                      <IconButton>
                        <Switch
                          checked={checked}
                          // onChange={(e) => {

                          // }}
                          onChange={(e) => {
                            handleSwitchChange(e, row.original.courseId);
                          }}
                          color="secondary"
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                ) : (
                  ""
                )}

                <Tooltip title="Go To Course Details Page">
                  <IconButton>
                    <span
                      onClick={() => {
                        goToViewCourse(row.original.courseId);
                      }}
                    >
                      <img src={actionIcon} alt="action icon" />
                    </span>
                  </IconButton>
                </Tooltip>

                {/* {cookies.roleId === UserRole.ORGANISATION_CORDINATOR ? (
              <>
                <Tooltip title="Delete Course">
                  <IconButton>
                    <span
                      onClick={() => {
                        confirmDeleteCourse(row.original);
                      }}
                    >
                      <img src={deleteIcon} alt="delete icon" />
                    </span>
                  </IconButton>
                </Tooltip>
              </>
            ) : null} */}
              </div>
            </>
          );
        },
      },
    ];

    const additionalColumns = [
      // {
      //   accessorKey: "totalParticipants",
      //   header: "Total Trainees",
      //   cell: ({ getValue }) => (
      //     <span
      //       style={{ whiteSpace: "normal", textAlign: "center", width: "5%" }}
      //     >
      //       {getValue()}
      //     </span>
      //   ),
      //   size: "5%",
      // },
      // {
      //   accessorKey: "completionPercentage",
      //   header: "Completion(%)",
      //   cell: ({ getValue }) => (
      //     <span
      //       style={{ whiteSpace: "normal", textAlign: "center", width: "5%" }}
      //     >
      //       {getValue()}
      //     </span>
      //   ),
      //   size: "5%",
      // },
    ];

    return cookies.roleId === "organizationCoordinator"
      ? [...baseColumns, ...additionalColumns]
      : baseColumns;
  }, [cookies.roleId, navigate, displayType]);

  const renderCards = () => {
    return (
      <Row className="g-4">
        {data.map((course) => (
          <Col key={course.courseId} md={4}>
            <Card>
              <Card.Body>
                <Card.Title>{course.title}</Card.Title>
                <Card.Text>{course.description}</Card.Text>
                <Card.Text>
                  <small>Level: {course.level}</small>
                </Card.Text>
                <Button
                  variant="primary"
                  onClick={() => {
                    console.log("Selected Course ID:", course.courseId); // Log the selected course ID
                    navigate(`/about-course/${course.courseId}`); // Navigate to the course details page
                  }}
                >
                  View Course
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    );
  };
  const deBouncedHandleCourseSearch = (e) => {
    if (e.target.value === "") {
      setData(allCourses);
      return;
    }
    const result = allCourses.filter((course) => {
      return (
        course.title?.toLowerCase()?.includes(e.target.value?.toLowerCase()) ||
        course.courseDepartment
          ?.toLowerCase()
          ?.includes(e.target.value?.toLowerCase())
      );
    });

    setData(result);
  };
  const handleCourseSearch = _.debounce(deBouncedHandleCourseSearch, 1000);
  const confirmDeleteCourse = (course) => {
    setClickedCourse(course);
    setOpenDeleteCOnfirmationModal(true);
  };
  const handleDeleteConfirmationModalClose = () => {
    setOpenDeleteCOnfirmationModal(false);
  };
  const handleDeleteConfirm = async () => {
    setIsDeleteCourseLoading(true);

    const payload = {
      courseId: clickedCourse?.courseId,
      authorUserId: cookies.userId,
      creationType: "deleteCourse",
    };
    const response = await createCourseDetails(payload);
    if (response.status === 201) {
      setShowToastMessage(true);
      setOpenDeleteCOnfirmationModal(false);
    }
    setIsDeleteCourseLoading(false);
  };

  const handleToastMessageClose = () => {
    setShowToastMessage(false);
  };

  return (
    <Fragment>
      <Row>
        <Col>
          <CommonHeader
            text="View Course"
            subText="Add or edit courses."
            icon={courseIcon}
          />
        </Col>
      </Row>

      <Row className="mx-auto">
        <Col sm={10} className="mx-auto pt-5 px-0">
          <Card>
            <Card.Body className="p-4 mb-2">
              {/* <Tabs
                value={tabValue}
                onChange={handleTabChange}
                textColor="primary"
                indicatorColor="primary"
                aria-label="primary tabs example"
              >
                <Tab value="draft" label="Draft" />
                <Tab value="published" label="Published" />
              </Tabs> */}

              <ul className="nav nav-tab w-100 d-flex align-items-center mb-4">
                <li className="nav-item bg-light p-1">
                  <button
                    className={`nav-link rounded ${displayType === "draft" ? "font-bold" : "text-secondary"}`}
                    style={displayType === "draft" ? activeTabStyle : {}}
                    onClick={() => setDisplayType("draft")}
                  >
                    DRAFT
                  </button>
                </li>
                <li className="nav-item bg-light p-1">
                  <button
                    className={`nav-link rounded ${displayType === "published" ? "font-bold" : "text-secondary"}`}
                    style={displayType === "published" ? activeTabStyle : {}}
                    onClick={() => setDisplayType("published")}
                  >
                    PUBLISHED
                  </button>
                </li>
              </ul>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <TextField
                  size="small"
                  variant="outlined"
                  placeholder="Search for course, department, domain"
                  InputProps={{ startAdornment: <SearchIcon /> }}
                  onChange={handleCourseSearch}
                  className="mb-2"
                  style={{ width: "350px" }}
                />
                <div className="d-flex align-items-center gap-4">
                  <RefreshButton
                    handleRefresh={handleRefresh}
                    title="Refresh Domain"
                    isRefreshing={isRefreshing}
                  />
                  {hasFeature(FEATURES.COURSE_UPLOAD) && displayType === "draft" && (
                    <Button variant="primary" onClick={handleAddCourse}>
                      <AddIcon /> Add Course
                    </Button>
                  )}
                </div>
              </div>

              <div className="mt-3">
                {loading ? (
                  <div className="text-center p-4">
                    <Spinner animation="border" />
                  </div>
                ) : isTableView ? (
                  <TanstackTable
                    data={data}
                    columns={columns}
                    pagination={true}
                  />
                ) : (
                  renderCards()
                )}
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* delete confirmation modal */}
      <ConfirmationDialog
        open={openDeleteCOnfirmationModal}
        message="Are you sure to delete the course"
        handleClose={handleDeleteConfirmationModalClose}
        handleConfirm={handleDeleteConfirm}
        isLoading={isDeleteCourseLoading}
      />

      {/* show toast message after deleteing the course */}
      <ToastMessage
        open={showToastMessage}
        message="Course Marked As Deleted"
        closeTiming={3000}
        handleClose={handleToastMessageClose}
      />
      {/* confirmation dialog for publish course */}
      <ConfirmationDialog
        open={shouldPublishCourse}
        handleClose={handleCloseForPublishCourse}
        handleConfirm={handleStatusToggle}
        isLoading={publishCourseLoading}
        message="Do you want to publish this course"
      />
    </Fragment>
  );
};

export default AllCourses;
